import React from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material';
import { IngestRun } from '../../types';
import { formatDateTime } from '../../utils/format';
import { durationLabel, formatCount, readAgo, triggerLabel } from '../../utils/jobSources';

interface Props {
  runs: IngestRun[];
}

/** The last refresh passes, newest first. Scrolls sideways on a narrow screen. */
const RecentRuns: React.FC<Props> = ({ runs }) => (
  <Paper variant="outlined" component="section" aria-labelledby="sources-runs-title">
    <Typography id="sources-runs-title" variant="h6" component="h2" sx={{ fontWeight: 700, px: 2, pt: 2 }}>
      Recent runs
    </Typography>
    <Typography variant="body2" color="text.secondary" sx={{ px: 2, pb: 1 }}>
      The latest refresh passes, newest first. Created, updated and retired count jobs.
    </Typography>
    {runs.length === 0 ? (
      <Typography variant="body2" color="text.secondary" sx={{ px: 2, pb: 2 }}>
        No refresh has run yet.
      </Typography>
    ) : (
      <TableContainer>
        <Table size="small" aria-labelledby="sources-runs-title" sx={{ minWidth: 720 }}>
          <TableHead>
            <TableRow>
              <TableCell>When</TableCell>
              <TableCell>Trigger</TableCell>
              <TableCell align="right">Boards</TableCell>
              <TableCell align="right">Failed</TableCell>
              <TableCell align="right">Created</TableCell>
              <TableCell align="right">Updated</TableCell>
              <TableCell align="right">Retired</TableCell>
              <TableCell align="right">Remaining</TableCell>
              <TableCell align="right">Duration</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {runs.map((run) => (
              <TableRow key={run.id}>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>
                  <Tooltip title={formatDateTime(run.started_at)}>
                    <span>{readAgo(run.started_at)}</span>
                  </Tooltip>
                </TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>{triggerLabel(run.trigger)}</TableCell>
                <TableCell align="right">{formatCount(run.boards)}</TableCell>
                <TableCell align="right" sx={{ color: run.failed > 0 ? 'warning.dark' : undefined, fontWeight: run.failed > 0 ? 700 : undefined }}>
                  {formatCount(run.failed)}
                </TableCell>
                <TableCell align="right">{formatCount(run.created)}</TableCell>
                <TableCell align="right">{formatCount(run.updated)}</TableCell>
                <TableCell align="right">{formatCount(run.deactivated)}</TableCell>
                <TableCell align="right">{formatCount(run.remaining)}</TableCell>
                <TableCell align="right" sx={{ whiteSpace: 'nowrap' }}>
                  {durationLabel(run.seconds)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    )}
  </Paper>
);

export default RecentRuns;
